
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(3(18|67|75)|153|238)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
